import { createNamespace, isEmpty } from '../../utils'; // Components

var _createNamespace = createNamespace('prescription'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    date: function date() {
      var _this$detail = this.detail,
          advisoryType = _this$detail.advisoryType,
          serviceAuditTime = _this$detail.serviceAuditTime,
          serviceAuditStatus = _this$detail.serviceAuditStatus,
          doctorAuditTime = _this$detail.doctorAuditTime,
          doctorAuditStatus = _this$detail.doctorAuditStatus;
      var date = null; // 审核通过的时候展示时间

      if (serviceAuditStatus === 1 && (advisoryType === 1 || advisoryType === 2)) date = serviceAuditTime;
      if (doctorAuditStatus === 1 && advisoryType === 4) date = doctorAuditTime;
      return isEmpty(date) ? '' : this.formatFullDate(new Date(date));
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    sex: function sex(_sex) {
      if (_sex === 1) {
        return '男';
      }

      if (_sex === 0) {
        return '女';
      }

      return '未填写';
    },
    formatDate: function formatDate(date) {
      if (date) {
        return date.getMonth() + 1 + "\u6708" + date.getDate() + "\u65E5";
      }
    },
    formatFullDate: function formatFullDate(date) {
      if (date) {
        return date.getFullYear() + "\u5E74" + this.formatDate(date);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$detail2 = this.detail,
        prescriptionType = _this$detail2.prescriptionType,
        hospitalName = _this$detail2.hospitalName,
        id = _this$detail2.id,
        _this$detail2$name = _this$detail2.name,
        name = _this$detail2$name === void 0 ? '' : _this$detail2$name,
        gender = _this$detail2.gender,
        age = _this$detail2.age,
        storeContactInfo = _this$detail2.storeContactInfo,
        dept = _this$detail2.dept,
        prescriptionTotalStatus = _this$detail2.prescriptionTotalStatus,
        symptom = _this$detail2.symptom,
        illness = _this$detail2.illness,
        allergy = _this$detail2.allergy,
        date = this.date;
    return h("div", {
      "class": bem('base-info')
    }, [h("h2", {
      "class": bem('base-info--title')
    }, [hospitalName]), h("Image", {
      "class": bem('base-info--normal-remark'),
      "attrs": {
        "width": "44px",
        "height": "44px",
        "fit": "contain",
        "src": "https://static.91jkys.com/collection/capui-mobile/image/prescription/normal_prescription.png"
      }
    }), h("div", {
      "class": bem('base-info--content')
    }, [h("div", {
      "class": bem('base-info--order')
    }, [h("span", {
      "class": bem('bold')
    }, ["\u5904\u65B9\u5355\u53F7: "]), h("span", [id])]), name.length > 5 ? h("div", {
      "class": bem('space-between')
    }, [h("span", ["\u59D3\u540D: ", name || '未填写'])]) : '', h("div", {
      "class": bem('space-between')
    }, [name.length <= 5 ? h("span", ["\u59D3\u540D: ", name || '未填写']) : '', h("span", ["\u6027\u522B: ", this.sex(gender)]), h("span", ["\u5E74\u9F84: ", age, "\u5C81"]), storeContactInfo && storeContactInfo.showCity ? h("span", [storeContactInfo.showCity]) : '']), h("div", {
      "class": bem('space-between')
    }, [h("span", ["\u79D1\u522B: ", dept || '未填写']), date ? h("span", ["\u65E5\u671F: ", date]) : '']), prescriptionTotalStatus !== 2 || prescriptionType === 1 ? h("div", {
      "class": bem('base-info--symptom')
    }, [prescriptionType === 1 ? '证型' : '主诉', ":", ' ', prescriptionType === 1 ? illness : symptom]) : '', h("div", {
      "class": bem('base-info--illness')
    }, [prescriptionType === 1 ? '病名' : '诊断', ":", ' ', prescriptionType === 1 ? symptom || '待补充' : illness || '待补充']), allergy ? h("div", {
      "class": bem('base-info--allergy')
    }, [h("span", ["\u8FC7\u654F\u53F2: "]), h("span", [allergy])]) : null])]);
  }
});